// extracted by mini-css-extract-plugin
export var block = "style-module--block--375fc";
export var container = "style-module--container--78515";
export var revs = "style-module--revs--28a25";